import { type UseModalState } from "@src/lib/ui-react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ShiftInviteStepper } from "../Stepper";
import { NearbyWorkerSearchResult } from "src/containers/Shift/ShiftInvites/Autocomplete/useGetNearbyWorkers";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useShiftInviteContext } from "../Context/shiftInviteContext";
import { isEmpty } from "lodash";

export interface ShiftInviteDialogProps {
  workerType: string;
  shiftInfo: {
    start: string;
    end: string;
    shiftType: string;
    timezone?: string;
  };
  modalState: UseModalState;
  initialActiveState?: number;
  initialSelectedWorker?: NearbyWorkerSearchResult;
}

export function ShiftInviteDialog(props: ShiftInviteDialogProps): JSX.Element {
  const { modalState, initialActiveState = 0 } = props;
  const [activeStep, setActiveStep] = useState(initialActiveState);
  const { addUserJourneyEvent, logUserJourney, shiftInviteUserJourney } = useShiftInviteContext();

  if (isEmpty(shiftInviteUserJourney)) {
    addUserJourneyEvent("open", "Shift Invite Modal");
  }

  return (
    <Dialog
      open={modalState.modalIsOpen}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick") {
          modalState.closeModal();
        } else {
          addUserJourneyEvent("click", "Backdrop");
        }
      }}
      aria-labelledby="shift-invite-dialog-title"
      aria-describedby="shift-invite-dialog-description"
      maxWidth={activeStep === 0 ? "lg" : "xl"}
    >
      <DialogTitle>Invite a Professional</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => {
          logUserJourney("exit", "Close Button");
          modalState.closeModal();
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <ShiftInviteStepper onActiveStepChange={setActiveStep} {...props} />
      </DialogContent>
    </Dialog>
  );
}
